<template>
<w-settings-content-template slot="activeView" :default-content="false" v-loading="managegrpObjData.loading">
  <!-- 논리 그룹 트리 -->
  <el-row slot="title" style="padding-right:20px; width:100%;" type="flex" justify="space-between" align="middle">
    <div style="line-height:28px;">논리 그룹</div>
    <el-button type="solid" @click="startGroupTreeEditMode">편집</el-button>
  </el-row>
  <!-- 0312 스타일 추가 -->
  <el-tree style="text-align:left" slot="sideContent" ref="logicalGroupTree" :data="logicalTreeData" :props="defaultProps" :node-key="defaultProps.treeKey" :expand-on-click-node="false" highlight-current default-expand-all @current-change="onCurrentGroupNodeChange"
    @node-click="onGroupNodeClick">
  </el-tree>
  <div class="content" style="height:100%;" slot="content">
    <!-- 물리 그룹 트리 -->
    <div :class="[$style['physical-tree-wrapper'], 'mr-r30']">
      <div class="title-h3 title-bar">[{{selectedGroupName}}] 관리 대상 선택 </div>
      <el-row v-show="!showInterfaceList" class="title-bar" type="flex" justify="space-between" align="middle">
        <w-obj-type-filter ref="objTypeFilter" :init-load="true" @filter-change="onObjTypeChange" />
        <div class="vertical-center-box">
          <el-select v-model="unregisteredKey" size="mini" style="width:115px" class="mr-r4">
            <el-option v-for="item in unregisteredKeyList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <el-button type="primary" :disabled="!managegrpObjData.modified" @click="saveManagegrpObjChange(false)" class="mr-r4">저장</el-button>
          <el-button :disabled="!managegrpObjData.modified" @click="cancelManagegrpObjChange" class="mr-r4">취소</el-button>
          <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool" />
        </div>
      </el-row>
      <div v-show="!showInterfaceList" style=" width:100%; height: calc(100% - 60px)">
        <w-physical-obj-table style="" :fit-height="true" ref="physicalTable" :params="tableParams" :data="managegrpObjData.editData" @load="loadManagegrpObj"
        :total="managegrpObjData.total" :show-custom-header="true" :show-search-tool="showSearchTool" @selection-change="onSelectionChange"
        @on-click-interfae-button="onClickInterfaceButton"/>
      </div>
      <w-interface-table v-show="showInterfaceList" ref="interfaceTable" style=" width:100%; height: calc(100% - 60px)" :fit-height="true" :active="showInterfaceList" :device-data="selectedDeviceData"
      :filter-params="tableParams" :checked-obj-list="objOrderData.originalData.filter((item) => item.objDefineId === 'NETINTERFACE')" @on-click-back-button="onClickBackButton"
      @on-click-save-button="saveManagegrpObjChange(true)" :unregistered-key="unregisteredKey"/>
    </div>
    <!-- 그룹 관리 대상 -->
    <div :class="$style['obj-list-wrapper']" v-loading="objOrderData.loading">
      <div class="title-h3 title-bar">[{{selectedGroupName}}] 관리 대상 - <em class="mr-l5"> {{filteredGroupObjData.length}}대</em></div>
      <el-row class="title-bar" type="flex" justify="space-between" align="middle">
        <div>
          <span class="setting-addel mr-r4">
            <el-button size="mini" @click="onChangeCheckedFlag(true)"><i class="fas fa-check-square" /></el-button>
            <el-button size="mini" @click="onChangeCheckedFlag(false)"><i class="far fa-square" /></el-button>
          </span>
          <el-button :disabled="!objOrderData.checked" @click="onObjOrderDataDelete">삭제</el-button>
        </div>
        <div>
          <el-button type="primary" :disabled="!objOrderData.modified" @click="saveObjOrderChange">저장</el-button>
          <el-button :disabled="!objOrderData.modified" @click="cancelObjOrderChange">취소</el-button>
          <w-header-search-button size="mini" @click="showGroupObjSearchTool = !showGroupObjSearchTool" />
        </div>
      </el-row>
      <w-search-field class="mr-b10" v-show="showGroupObjSearchTool" ref="groupObjSearchField" @search="onGroupObjSearch" />
      <div style="height:calc(100% - 60px);">
        <el-scrollbar>
          <div>
            <ul>
              <draggable class="list-drag-box" element="ul" v-model="filteredGroupObjData" @end="checkObjOrderDataChange">
                <li v-for="obj in filteredGroupObjData" :key="obj.objId">
                  <el-checkbox style="margin-right: 7px;" v-model="obj.checked" @change="checkObjOrderSelection"></el-checkbox>
                  <div class="label">{{getObjLabel(obj)}}</div>
                </li>
              </draggable>
            </ul>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</w-settings-content-template>
</template>

<script>
import draggable from 'vuedraggable';
import { isEmpty, findIndex, filter, cloneDeep, uniq, xorBy, forEach, map } from 'lodash';
import { defaultProps } from '@/constants/tree';
import TreeFilter from '@/mixins/tree/filter';
import messageUtil from '@/utils/message';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import logicalGroupApi from '@/api/settings/common/logical-group';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WSearchField from '@/components/form/SearchField';
import WObjTypeFilter from '@/components/table/PhysicalObjTable/ObjTypeFilter';
import WPhysicalObjTable from './components/PhysicalObjTable';
import WInterfaceTable from './components/InterfaceTable';

export default {
  name: 'WLogicalGroupConfigView',
  mixins: [TreeFilter],
  components: {
    draggable,
    WSettingsContentTemplate,
    WObjTypeFilter,
    WPhysicalObjTable,
    WInterfaceTable,
    WSearchField,
  },
  props: {
    /**
     * 논리 그룹 트리 데이터
     * @type {Object}
     */
    treeData: {
      type: Array,
    },
    /**
     * 논리 그룹 관리 대상 설정 화면 제공 여부
     * @type {Object}
     */
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      /**
       * 논리 그룹 트리 데이터
       * @type {Array}
       */
      logicalTreeData: [],
      /**
       * 기본 트리 props 객체
       * @type {Object}
       */
      defaultProps,
      /**
       * 선택한 논리 그룹 데이터 객체
       * @type {Object}
       */
      selectedGroupData: null,
      /**
       * 선택한 논리 그룹 노드 키
       * @type {String}
       */
      selectedGroupTreeKey: null,
      /**
       * 장비 구분 파라미터
       * @type {Object}
       */
      objTypeParams: null,
      /**
       * 물리 그룹 장비 테이블 파라미터
       * @type {Object}
       */
      physcalTableParams: {},
      /**
       * 헤더 검색 제공 여부
       * @type {Boolean}
       */
      showSearchTool: false,
      /**
       * 그룹 관리 대상 검색 컴포넌트 제공 여부
       * @type {Boolean}
       */
      showGroupObjSearchTool: false,
      /**
       * 그룹 관리 대상 검색 키워드
       * @type {[type]}
       */
      groupObjSearchKeyword: null,
      /**
       * 논리 그룹 관리 대상 데이터
       * @type {Object}
       */
      managegrpObjData: {
        originalData: [],
        editData: [],
        modified: false,
        loading: false,
      },
      /**
       * 논리 그룹 관리 대상 정렬 데이터
       * @type {Object}
       */
      objOrderData: {
        loading: false,
        originalData: [],
        editData: [],
        modified: false,
        checked: false,
      },
      showInterfaceList: false,
      selectedDeviceData: {},
      unregisteredKeyList: [
        {
          label: '전체',
          value: 'ALL',
        },
        {
          label: '그룹 미등록 장비',
          value: 'GROUP',
        },
        {
          label: '전체 미등록 장비',
          value: 'ROOT',
        },
      ],
      unregisteredKey: 'ALL',
    };
  },
  computed: {
    /**
     * 선택된 논리 그룹명
     * 없을 경우 '-'을 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    selectedGroupName() {
      return isEmpty(this.selectedGroupData) || isEmpty(this.selectedGroupData.label) ? EMPTY_TEXT : this.selectedGroupData.label;
    },
    /**
     * 물리 그룹 장비 테이블 전달 파라미터
     * @author Ju
     * @return {[type]} [description]
     */
    tableParams() {
      let tableParams = {};
      if (!isEmpty(this.selectedGroupData) && !isEmpty(this.objTypeParams)) {
        const params = {
          managegroupId: this.selectedGroupData.managegroupId,
          unregisteredKey: this.unregisteredKey === 'ALL' ? null : this.unregisteredKey,
          ...this.objTypeParams.params,
        };
        tableParams = {
          params,
          columns: this.objTypeParams.columns,
        };
      }
      return tableParams;
    },
    /**
     * 필터링된 그룹 관리 대상 데이타
     * @author Ju
     * @return {[type]} [description]
     */
    filteredGroupObjData: {
      get() {
        if (isEmpty(this.groupObjSearchKeyword)) {
          return this.objOrderData.editData;
        }
        const keyword = this.groupObjSearchKeyword.toLowerCase();
        return filter(
          this.objOrderData.editData,
          (item) =>
            this.getObjLabel(item)
              .toLowerCase()
              .indexOf(keyword) > -1,
        );
      },
      set(editData) {
        this.objOrderData.editData = editData;
      },
    },
  },
  watch: {
    /**
     * 논리 그룹 관리 대상 설정 제공 여부
     * true: 제공 → 데이터 로드
     * false: 숨김 → 데이터 초기화
     */
    visible: {
      // immediate: true,
      handler(to) {
        if (to === true) {
          this.loadData();
        } else {
          this.resetData();
        }
      },
    },
    /**
     * 해당 화면 제공 상태일 때만 props로 전달된 논리 그룹 트리 데이터 바인딩
     * @author Ju
     */
    treeData() {
      if (this.visible === true) {
        this.logicalTreeData = this.treeData;
      }
    },
    /**
     * 논리 그룹 트리 데이터 바인딩
     * 데이터 바인딩 시 첫 번째 그룹이 자동으로 선택되도록 한다.
     * @author Ju
     * @param  {[type]} to [description]
     * @return {[type]}    [description]
     */
    logicalTreeData(to) {
      if (!isEmpty(to)) {
        this.$nextTick(() => {
          const logicalGroupTree = this.$refs.logicalGroupTree;
          const root = logicalGroupTree.root.childNodes[0];

          if (!isEmpty(root.childNodes)) {
            const firstGroupNode = root.childNodes[0];
            const firstGroupTreeKey = firstGroupNode.data.treeKey;
            logicalGroupTree.setCurrentKey(firstGroupTreeKey);
            this.selectedGroupTreeKey = firstGroupTreeKey;
            this.onCurrentGroupNodeChange(firstGroupNode.data, firstGroupNode);
          }
        });
      }
    },
    objTypeParams(to, from) {
      if ((isEmpty(from) || to.params.managetypeId !== from.params.managetypeId || to.params.managetypeKey !== from.params.managetypeKey) && this.showSearchTool) {
        this.showSearchTool = false;
      }
    },
  },
  methods: {
    /**
     * 화면의 데이터들을 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      this.logicalTreeData = this.treeData;
      this.$refs.objTypeFilter.loadManagetype();
    },
    /**
     * 이전에 설정된 값들을 초기화한다.
     * @author Ju
     */
    resetData() {
      this.selectedGroupData = null;
      this.selectedGroupTreeKey = null;
      this.physicalTreeParams = {
        managetypeId: null,
        managetypeKey: null,
      };

      this.objOrderData = {
        originalData: [],
        editData: [],
        loading: false,
        modified: false,
      };

      this.managegrpObjData = {
        originalData: [],
        editData: [],
        loading: false,
        modified: false,
      };
    },
    /**
     * 논리 그룹 트리를 편집한다.
     * @author Ju
     * @return {[type]} [description]
     */
    startGroupTreeEditMode() {
      this.$emit('change-edit-mode', true);
    },
    /**
     * 논리 그룹 트리 노드 변경 이벤트 핸들러
     * @author Ju
     * @param  {[type]} data [description]
     * @param  {[type]} node [description]
     * @return {[type]}      [description]
     */
    onCurrentGroupNodeChange(data, node) {
      if (node.level !== 1) {
        // root는 선택되지 않도록 함.
        this.selectedGroupData = data;
        this.insertObjList = [];
        this.deleteObjList = [];
        this.loadObjOfGroup(this.selectedGroupData.managegroupId);
      }
    },
    /**
     * 논리 그룹 트리 노드 클릭 이벤트 핸들러
     * @author Ju
     * @param  {[type]} data    [description]
     * @param  {[type]} node    [description]
     * @param  {[type]} nodeCmp [description]
     * @return {[type]}         [description]
     */
    onGroupNodeClick(data, node, nodeCmp) {
      if (node.level === 1) {
        // root 노드는 선택되지 않도로 막음.
        nodeCmp.$el.blur();
        const logicalGroupTree = this.$refs.logicalGroupTree;
        logicalGroupTree.setCurrentNode(logicalGroupTree.getNode(this.selectedGroupTreeKey));
      } else {
        this.selectedGroupTreeKey = data.treeKey;
      }
    },
    /**
     * 장비 구분 변경 이벤트 핸들러
     * @author Ju
     * @param  {[type]} params [description]
     * @return {[type]}        [description]
     */
    onObjTypeChange(params, columns) {
      this.objTypeParams = {
        params,
        columns,
      };
    },
    /**
     * 물리 그룹 관리 대상 정보 조회
     * @author Ju
     * @param  {[type]} params [description]
     * @return {[type]}        [description]
     */
    loadManagegrpObj(params) {
      let tableParams;
      if (isEmpty(params)) {
        tableParams = this.physcalTableParams;
      } else {
        this.physcalTableParams = params;
        tableParams = params;
      }
      this.managegrpObjData.loading = true;
      logicalGroupApi
        .getPhysicalObjList(tableParams)
        .then((response) => {
          this.managegrpObjData.loading = false;
          this.managegrpObjData.modified = false;
          const result = response.data;
          if (!isEmpty(result) && result.success === true && !isEmpty(result.data)) {
            this.managegrpObjData.editData = result.data;
            this.managegrpObjData.total = result.total;

            const originalData = filter(result.data, (item) => item.checked);
            this.managegrpObjData.originalData = originalData;
            this.$nextTick(() => {
              this.$refs.physicalTable.toggleRowSelection(originalData);
            });
          } else {
            this.managegrpObjData.editData = [];
            this.managegrpObjData.total = 0;
          }
        })
        .catch(() => {
          this.managegrpObjData.loading = false;
          this.managegrpObjData.editData = [];
          this.managegrpObjData.total = 0;
        });
    },
    /**
     * 물리 그룹 관리 대상 테이블 체크 변경 이벤트 핸들러
     * @author Ju
     * @param  {[type]} selection [description]
     * @return {[type]}           [description]
     */
    onSelectionChange(selection) {
      const diffData = uniq(xorBy(this.managegrpObjData.originalData, selection, 'objId'));
      this.managegrpObjData.modified = diffData.length > 0;
    },
    /**
     * 그룹의 관리 대상 변경 내용을 저장한다. (추가/수정/삭제)
     * @author Ju
     */
    saveManagegrpObjChange(isInterfaceTable) {
      let insertObjList = [];
      let deleteObjList = [];
      const managegroupId = this.selectedGroupData.managegroupId;

      if (isInterfaceTable) {
        insertObjList = this.$refs.interfaceTable.getObjList().insertObjList.map((obj) => ({
          managegroupId,
          ...obj,
        }));
        deleteObjList = this.$refs.interfaceTable.getObjList().deleteObjList.map((obj) => ({
          managegroupId,
          ...obj,
        }));
      } else {
        const editData = this.$refs.physicalTable.getSelection();
        if (isEmpty(editData) && isEmpty(this.managegrpObjData.originalData)) {
          return;
        }

        const originalData = this.managegrpObjData.originalData;
        if (isEmpty(originalData)) {
          // 기존에 관리 대상이 없는 경우
          forEach(editData, (obj) => {
            insertObjList.push({
              managegroupId,
              objId: obj.objId,
            });
          });
        } else {
          // 기존에 관리 대상이 있는 경우
          const existObjIds = [];
          forEach(editData, (obj) => {
            const objId = obj.objId;
            const originalIndex = findIndex(originalData, (originalObj) => objId === originalObj.objId);
            if (originalIndex < 0) {
              // 추가
              insertObjList.push({
                managegroupId,
                objId,
              });
            } else {
              existObjIds.push(objId);
            }
          });

          // 삭제
          if (isEmpty(existObjIds)) {
            forEach(this.managegrpObjData.originalData, (obj) => {
              deleteObjList.push({
                managegroupId,
                objId: obj.objId,
              });
            });
          } else {
            forEach(this.managegrpObjData.originalData, (obj) => {
              if (existObjIds.indexOf(obj.objId) < 0) {
                deleteObjList.push({
                  managegroupId,
                  objId: obj.objId,
                });
              }
            });
          }
        }
      }
      if (!isEmpty(insertObjList) || !isEmpty(deleteObjList)) {
        const params = {
          INSERT: isEmpty(insertObjList) ? null : insertObjList,
          DELETE: isEmpty(deleteObjList) ? null : deleteObjList,
        };
        const target = `${this.selectedGroupName}의 관리 대상`;
        const action = messageUtil.action.SAVE;
        logicalGroupApi
          .updateManageGrpObj(params)
          .then((response) => {
            if (!isEmpty(response.data) && response.data.success === true) {
              this.$message(messageUtil.getResultMsgData(action, target, true));
              if (isInterfaceTable) {
                this.$refs.interfaceTable.loadData();
              } else {
                this.loadManagegrpObj();
              }
              this.loadObjOfGroup(this.selectedGroupData.managegroupId);
            } else {
              this.$message(messageUtil.getResultMsgData(action, target, false));
            }
          })
          .catch(() => {
            this.$message(messageUtil.getResultMsgData(action, target, false));
          });
      }
    },
    /**
     * 논리 그룹 관리 대상 변경 사항을 취소한다.
     * @author Ju
     * @return {[type]} [description]
     */
    cancelManagegrpObjChange() {
      this.$refs.physicalTable.clearSelection();
      this.$refs.physicalTable.toggleRowSelection(this.managegrpObjData.originalData);
      this.managegrpObjData.modified = false;
    },
    /**
     * 그룹의 관리 대상 목록을 조회한다.
     * @author Ju
     * @param  {[type]} managegroupId [description]
     * @return {[type]}               [description]
     */
    loadObjOfGroup(managegroupId) {
      this.isLoadingForObjList = true;
      this.$refs.groupObjSearchField.clear();
      logicalGroupApi
        .getObjListOfGroup(managegroupId)
        .then((response) => {
          this.isLoadingForObjList = false;
          this.objOrderData.modified = false;
          this.objOrderData.checked = false;
          if (!isEmpty(response.data) && response.data.success === true && !isEmpty(response.data.data)) {
            this.objOrderData.originalData = response.data.data;
            this.objOrderData.editData = cloneDeep(this.objOrderData.originalData);
          } else {
            this.objOrderData.originalData = [];
            this.objOrderData.editData = [];
          }
        })
        .catch(() => {
          this.isLoadingForObjList = false;
          this.objOrderData.modified = false;
          this.objOrderData.originalData = [];
          this.objOrderData.editData = [];
        });
    },
    /**
     * 그룹의 관리 대상 변경 내용을 저장한다. (추가/수정/삭제)
     * @author Ju
     */
    saveObjOrderChange() {
      const updateObjList = [];
      // 기존에 관리 대상이 있는 경우
      let orderbyIndex = 0;
      const managegroupId = this.selectedGroupData.managegroupId;
      forEach(this.objOrderData.editData, (obj) => {
        orderbyIndex += 1;
        const objId = obj.objId;
        const originalIndex = findIndex(this.objOrderData.originalData, (originalObj) => objId === originalObj.objId);
        if (originalIndex >= 0) {
          const originalObj = this.objOrderData.originalData[originalIndex];
          if (originalObj.orderbyIndex !== orderbyIndex) {
            updateObjList.push({
              managegroupId,
              objId,
              orderbyIndex,
            });
          }
        }
      });

      if (!isEmpty(updateObjList)) {
        const params = {
          UPDATE: updateObjList,
        };
        const target = `${this.selectedGroupName}의 관리 대상의 정렬 순서`;
        const action = messageUtil.action.MODIFY;
        logicalGroupApi
          .updateManageGrpObj(params)
          .then((response) => {
            if (!isEmpty(response.data) && response.data.success === true) {
              this.$message(messageUtil.getResultMsgData(action, target, true));
              this.loadObjOfGroup(this.selectedGroupData.managegroupId);
            } else {
              this.$message(messageUtil.getResultMsgData(action, target, false));
            }
          })
          .catch(() => {
            this.$message(messageUtil.getResultMsgData(action, target, false));
          });
      }
    },
    /**
     * 논리 그룹의 장비 구성 변경 내용르 이전으로 되돌린다.
     * @author Ju
     * @return {[type]} [description]
     */
    cancelObjOrderChange() {
      this.objOrderData.editData = cloneDeep(this.objOrderData.originalData);
      this.objOrderData.modified = false;
      this.objOrderData.checked = false;
    },
    /**
     * 논리 그룹 관리 대상 변경 여부를 확인한다.
     * @author Ju
     * @return {[type]} [description]
     */
    checkObjOrderDataChange() {
      let orderbyIndex = 0;
      let modified = false;
      forEach(this.objOrderData.editData, (obj) => {
        if (!modified) {
          const objId = obj.objId;
          const originalIndex = findIndex(this.objOrderData.originalData, (originalObj) => objId === originalObj.objId);
          if (originalIndex !== orderbyIndex) {
            modified = true;
          }
          orderbyIndex += 1;
        }
      });

      this.objOrderData.modified = modified;
    },
    /**
     * 논리 그룹 관리 대상 선택 여부를 확인한다.
     * @author Ju
     * @return {[type]} [description]
     */
    checkObjOrderSelection() {
      let checked = false;
      forEach(this.objOrderData.editData, (item) => {
        if (!checked) {
          if (item.checked) {
            checked = true;
          }
        }
      });

      this.objOrderData.checked = checked;
    },
    /**
     * 선택한 관리 대상을 삭제한다.
     * @author Ju
     * @return {[type]} [description]
     */
    onObjOrderDataDelete() {
      const deleteList = filter(this.objOrderData.editData, (item) => item.checked);
      if (!isEmpty(deleteList)) {
        const managegroupId = this.selectedGroupData.managegroupId;
        const deleteObjList = [];
        forEach(deleteList, (obj) => {
          deleteObjList.push({
            managegroupId,
            objId: obj.objId,
          });
        });

        this.$confirm(...messageUtil.getBasicConfirmData(messageUtil.action.DELETE)).then(() => {
          const params = {
            DELETE: deleteObjList,
          };
          const target = '관리 대상';
          const action = messageUtil.action.DELETE;
          logicalGroupApi
            .updateManageGrpObj(params)
            .then((response) => {
              if (!isEmpty(response.data) && response.data.success === true) {
                this.$message(messageUtil.getResultMsgData(action, target, true));
                this.loadManagegrpObj();
                this.loadObjOfGroup(managegroupId);
              } else {
                this.$message(messageUtil.getResultMsgData(action, target, false));
              }
            })
            .catch(() => {
              this.$message(messageUtil.getResultMsgData(action, target, false));
            });
        });
      }
    },
    getObjLabel(data) {
      if (data.objDefineId === 'SERVICE' || data.objDefineId === 'E2E_SERVICE') {
        return data.objName;
      }
      return `${data.objName} (${getValueAfterCheckEmpty(data.ipaddress)})`;
    },
    onGroupObjSearch(value) {
      this.groupObjSearchKeyword = value;
    },
    /**
     * 관리 대상을 전체 선택/해제 한다.
     * @param  {[type]} flag [description]
     * @return {[type]}      [description]
     * @author jda
     */
    onChangeCheckedFlag(flag) {
      const objData = cloneDeep(this.filteredGroupObjData);
      map(objData, (data) => {
        data.checked = flag;
      });
      this.objOrderData.editData = objData;
      this.objOrderData.checked = flag;
    },
    onClickInterfaceButton(row) {
      this.selectedDeviceData = row;
      this.showInterfaceList = !this.showInterfaceList;
    },
    onClickBackButton(unregisteredKey) {
      this.unregisteredKey = unregisteredKey;
      this.showInterfaceList = !this.showInterfaceList;
    },
  },
};
</script>

<style module lang="scss">
.physical-tree-wrapper {
  height: 100%;
  width: calc(65% - 30px);
  float: left;
}

.obj-list-wrapper {
  height: 100%;
  width: 35%;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/LogicalGroupSettings/LogicalGroupConfigView.vue